import { render, staticRenderFns } from "./PrestacionSaludProgramasView.vue?vue&type=template&id=2a4e1b87"
import script from "./PrestacionSaludProgramasView.vue?vue&type=script&lang=ts"
export * from "./PrestacionSaludProgramasView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports